import { render } from "./TestimonialsSection.vue?vue&type=template&id=440bd0a6&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=440bd0a6&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440bd0a6"]])

export default __exports__